export const defaultHPCustomMessages = {
  HPBannerCloseModal: {
    title: "Switch Homepage Layouts",
    description:
      'You can change and customize Homepage layouts under <strong>"Preferences > Homepage"</strong>.'
  },
  HPSelector: {
    mobileMessage: "Select your homepage layout",
    desktopMessage: "Select the layout you want to see on your homepage"
  },
  HPWelcomeFeature: {
    title: "Choose your own homepage layout",
    isEnabled: true,
    message:
      "Explore our different homepage layouts and find the one that is right for you",
    ctaLabel: "Don’t show me again",
    coolDown: 2
  },
  templatesModal: {
    title: "Homepage Layout"
  },
  customModalMessages: {
    title: "Customize one of the layouts",
    description: "Pick a starting point for your custom layout"
  },
  showProfileTitleToggle: "HomepageLayout Selector",
  showProfileMessage: "Don't show Layout Selector at Homepage",
  HPCustomEmptyMessage: {
    title: "Custom Homepage",
    description:
      "Add sections and save your custom homepage layout. You can reset your custom layout to any of the default layouts as starting points for customization."
  },
  homepageConfigUserPreferencesContent: {
    title: "Homepage layout",
    description: "Select the layout you want to see on your homepage"
  },
  toastMessageSucess: "Custom layout saved and applied",
  customConfirmModal: {
    title: "Homepage layout",
    description:
      "This action will replace the current custom layout. Do you want to proceed?"
  },
  preferencesServiceMessages: {
    updateCustomHPOrder: {
      success: "Custom order for homepage updated successfully.",
      error: "Failed to update custom order for homepage."
    },
    updateUserTemplatePref: {
      success: "Layout preference updated successfully.",
      error: "Failed to update template preference."
    }
  },
  HPToastConfig: {
    successMessage: "Homepage layout applied",
    errorMessage: "Homepage were not applied",
    duration: 2000
  },
  layoutSelectorIconTooltip: "Layout Selector"
};
